// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountAttestationAttributeModel {
    static getAttributeTypeMap() {
        return AccountAttestationAttributeModel.attributeTypeMap;
    }
}
AccountAttestationAttributeModel.discriminator = undefined;
AccountAttestationAttributeModel.attributeTypeMap = [
    {
        "name": "attestationAttributeId",
        "baseName": "attestationAttributeId",
        "type": "number"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    }
];
//# sourceMappingURL=accountAttestationAttributeModel.js.map